import { GetStringKeys } from '../../../shared/types/get-string-keys.type';

export const setDateInputValue = <TFormikValuesModel>(
  setFieldValue: (
    field: string,
    value: Date | null,
    shouldValidate?: boolean
  ) => void,
  name: GetStringKeys<TFormikValuesModel>
): ((value: Date | null) => void) => {
  return function (value: Date | null) {
    setFieldValue(name, value);
  };
};
